import { useTranslation } from "react-i18next";
import { ReactFlow, Controls, Background } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { useEffect, useState } from "react";
import DeviceNode from "./nodes/DeviceNode";
import DatabaseNode from "./nodes/DatabaseNode";
import QueueNode from "./nodes/QueueNode";
import InstanceNode from "./nodes/InstanceNode";
import { Dcs0101Service } from "../../../../services/dcs/Dcs0101Service";
import { VariablesConstant } from "../../../../constants/variables";
import AppDialog from "../../../../components/commons/AppDialog";
import Dcs0101ViewData from "../view-data/Dcs0101ViewData";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { showAndHideSpinner } from "../../../../reducers/spinnerSlice";
import ConnectionInfo from "../components/ConnectionInfo";
import DataMapInfo from "../components/DataMapInfo";
import { ExceptionConstant } from "../../../../constants/exceptionConstant";
import { NotiService } from "../../../../services/noti/NotiService";
import Marquee from "react-fast-marquee";
import moment from "moment";
import ConnectionNotification from "../components/ConnectionNotification";
import ConnectionNotiItem from "../../../../components/commons/ConnectionNotiItem";

export default function ViewConnection(props: any) {
  const { t } = useTranslation();

  const [edges, setEdges] = useState<any>();
  const nodeTypes = { deviceNode: DeviceNode, instanceNode: InstanceNode, databaseNode: DatabaseNode, queueNode: QueueNode };
  const [nodes, setNodes] = useState<any>();

  const [connection, setConnection] = useState<any>();
  const [dataCycle, setDataCycle] = useState<any>();
  const [dataMap, setDataMap] = useState<any>();

  const [haveDataCycle, setHaveDataCycle] = useState<any>();
  const [haveSecModes, setHaveSecModes] = useState<any>(false);
  const [haveSecPolicies, setHaveSecPolicies] = useState<any>(false);

  const [delStatus, setDelStatus] = useState<any>();
  const [collStatus, setCollStatus] = useState<any>();

  const [openViewData, setOpenViewData] = useState<any>(false);
  const [openConnectionInfo, setOpenConnectionInfo] = useState<any>(false);
  const [openDataMap, setOpenDataMap] = useState<any>(false);
  const [openNotification, setOpenNotification] = useState<any>(false);

  const [loadingNodes, setLoadingNodes] = useState<any>(true);

  const message = useSelector((state: any) => state.socket.message);

  const [listNoti, setListNoti] = useState<any>();

  const dispatch = useDispatch();

  useEffect(() => {
    getConnDetail();
    setEdges([
      { id: "edge-1", source: "1", target: "2" },
      { id: "edge-2", source: "2", target: "3" },
      { id: "edge-3", source: "3", target: "4" },
      { id: "edge-4", source: "4", target: "5" },
    ]);
  }, []);

  useEffect(() => {
    if (message) {
      getConnDetail();
    }
  }, [message]);

  useEffect(() => {
    if (connection) {
      const updatedNodes = [
        {
          id: "1",
          data: { connection: connection, onEditConnectionInfo: editConnectionInfo, title: "Device" },
          position: { x: 100, y: 200 },
          type: "deviceNode",
        },
        {
          id: "2",
          data: { connection: connection, instanceTp: VariablesConstant.INSTANCE_TYPE_COLLECTION, status: collStatus, title: "Collection worker" },
          position: { x: 300, y: 200 },
          type: "instanceNode",
        },
        {
          id: "3",
          data: { title: "Queue" },
          position: { x: 600, y: 220 },
          type: "queueNode",
        },
        {
          id: "4",
          data: { connection: connection, instanceTp: VariablesConstant.INSTANCE_TYPE_DELIVERY, status: delStatus, title: "Delivery worker" },
          position: { x: 1050, y: 200 },
          type: "instanceNode",
        },
        {
          id: "5",
          data: { connection: connection, onViewData: viewData, onEditDataMap: editDataMap, title: "Database" },
          position: { x: 1300, y: 200 },
          type: "databaseNode",
        },
      ];
      setNodes(updatedNodes);
    }
  }, [connection, collStatus, delStatus]);

  useEffect(() => {
    if (nodes) {
      setLoadingNodes(false);
    }
  }, [nodes]);

  useEffect(() => {
    getConnNoti();
  }, []);

  const getConnNoti = () => {
    let req = { connId: props.connId, size: 10, page: 0 };
    NotiService.getInstance()
      .getNotiByConnId(req)
      .then((res) => {
        setListNoti(res.data.result.responseData.data);
      })
      .catch((err) => {});
  };

  const getConnDetail = () => {
    setLoadingNodes(true);
    Dcs0101Service.getInstance()
      .getConnectionDetail({ connectionId: props.connId })
      .then((res: any) => {
        setConnection(res.data.responseData);
        setDataMap(res.data.responseData.dataMap);
        setDataCycle(res.data.responseData.dataCycle);
        if (res.data.responseData.dataCycle && res.data.responseData.dataCycle != null) {
          setHaveDataCycle(true);
        }
        if (res.data.responseData.extraInfo && res.data.responseData.extraInfo.secModes) {
          setHaveSecModes(true);
        }
        if (res.data.responseData.extraInfo && res.data.responseData.extraInfo.secPolicies) {
          setHaveSecPolicies(true);
        }
        if (res.data.responseData.instance.length > 0) {
          res.data.responseData.instance.forEach((ele: any) => {
            if (ele.type === VariablesConstant.INSTANCE_TYPE_COLLECTION) {
              setCollStatus(ele.dpiStatus);
            } else {
              setDelStatus(ele.dpiStatus);
            }
          });
        } else {
          setCollStatus("");
          setDelStatus("");
        }
      })
      .catch((err: any) => {});
  };

  const start = async () => {
    dispatch(showAndHideSpinner(true));
    const checkConnection = await checkConnectionStatus();
    if (checkConnection) {
      let chkColl = true;
      let chkDel = true;
      try {
        const [resColl, resDel] = await Promise.allSettled([Dcs0101Service.getInstance().startColl({ connId: connection.id }), Dcs0101Service.getInstance().startDel({ connId: connection.id })]);
        if (resColl.status !== "fulfilled") {
          chkColl = false;
          await Dcs0101Service.getInstance().stopDel({ connId: connection.id });
        }
        if (resDel.status !== "fulfilled") {
          chkDel = false;
          await Dcs0101Service.getInstance().stopColl({ connId: connection.id });
        }

        if (chkColl && chkDel) {
          updateConnectionStatus(VariablesConstant.CONNECTION_STATUS_RUNNING);
          toast.success("Start connection successfully!");
        } else {
          updateConnectionStatus(VariablesConstant.CONNECTION_STATUS_STOPPED);
          toast.error("Start connection failed!");
        }
      } catch (error) {
        toast.error("Start connection failed!");
      } finally {
        dispatch(showAndHideSpinner(false));
      }
    } else {
      dispatch(showAndHideSpinner(false));
      toast.error("The data collection device is disconnected.!");
    }
  };

  const stop = async () => {
    try {
      dispatch(showAndHideSpinner(true));
      await Promise.all([Dcs0101Service.getInstance().stopColl({ connId: connection.id }), Dcs0101Service.getInstance().stopDel({ connId: connection.id })]);
      updateConnectionStatus(VariablesConstant.CONNECTION_STATUS_STOPPED);
      toast.success("Stop connection successfully!");
    } catch (error) {
      toast.error("Stop connection failed!");
    } finally {
      dispatch(showAndHideSpinner(false));
    }
  };

  const restart = async () => {
    dispatch(showAndHideSpinner(true));
    const checkConnection = await checkConnectionStatus();
    if (checkConnection) {
      try {
        await Promise.all([Dcs0101Service.getInstance().restartColl({ connId: connection.id }), Dcs0101Service.getInstance().restartDel({ connId: connection.id })]);
        updateConnectionStatus(VariablesConstant.CONNECTION_STATUS_RUNNING);
        toast.success("Restart connection successfully!");
      } catch (error) {
        await Promise.all([Dcs0101Service.getInstance().stopColl({ connId: connection.id }), Dcs0101Service.getInstance().stopDel({ connId: connection.id })]);
        updateConnectionStatus(VariablesConstant.CONNECTION_STATUS_STOPPED);
        toast.error("Restart connection failed!");
      } finally {
        dispatch(showAndHideSpinner(false));
      }
    } else {
      dispatch(showAndHideSpinner(false));
      toast.error("The data collection device is disconnected.!");
    }
  };

  const checkConnectionStatus = async () => {
    let chk = false;
    await Dcs0101Service.getInstance()
      .checkConnectionStatus({ connId: connection.id })
      .then((res) => {
        if (res.data.responseData) {
          chk = true;
        } else {
          chk = false;
        }
      })
      .catch((err) => {});
    return chk;
  };

  const updateConnectionStatus = (status: any) => {
    Dcs0101Service.getInstance()
      .updateConnectionStatus({ connId: connection.id, status: status })
      .then((res: any) => {
        getConnDetail();
      });
  };

  const back = () => {
    props.handleBack();
  };

  const viewData = () => {
    setOpenViewData(true);
  };

  const closeViewData = () => {
    setOpenViewData(false);
  };

  const editConnectionInfo = () => {
    setOpenConnectionInfo(true);
  };

  const closeConnectionInfo = () => {
    setOpenConnectionInfo(false);
  };

  const editDataMap = () => {
    setOpenDataMap(true);
  };

  const closeDataMap = () => {
    setOpenDataMap(false);
  };

  useEffect(() => {
    if (dataCycle) {
      setConnection({ ...connection, dataCycle: dataCycle });
    }
  }, [dataCycle]);

  useEffect(() => {
    if (dataMap) {
      setConnection({ ...connection, dataMap: dataMap });
    }
  }, [dataMap]);

  const handleChange = (event: any) => {
    setConnection({
      ...connection,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeProtTp = (event: any) => {
    setConnection({
      ...connection,
      connProtTp: event,
    });
    setDataMap([]);
  };

  const handleChangeConnectTp = (event: any) => {
    setConnection({
      ...connection,
      connectionType: event,
      extraInfo: {},
    });
  };

  const onAddRow = () => {
    setDataMap((prevItem: any) => [...prevItem, {}]);
  };

  const onDeleteRow = (index: any) => {
    if (connection.dataMapDel) {
      setConnection({ ...connection, dataMapDel: [...connection.dataMapDel, dataMap[index]] });
    } else {
      setConnection({ ...connection, dataMapDel: [...[], dataMap[index]] });
    }
    setDataMap(dataMap.filter((item: any, idx: any) => idx !== index));
  };

  const handleChangeDataMap = (event: any, index: any) => {
    setDataMap(dataMap.map((item: any, idx: any) => (idx === index ? { ...item, [event.target.name]: event.target.value } : item)));
  };

  const handleSelectSecModes = (event: any) => {
    setConnection({ ...connection, extraInfo: { ...connection.extraInfo, secModes: event.target.value } });
  };

  const handleSelectSecPolicies = (event: any) => {
    setConnection({ ...connection, extraInfo: { ...connection.extraInfo, secPolicies: event.target.value } });
  };

  const onChangeHaveDataCycle = (event: any) => {
    setHaveDataCycle(event.target.checked);
    if (!event.target.checked) {
      setConnection((prevModel: any) => {
        return {
          ...prevModel,
          dataCycle: undefined,
        };
      });
      setDataCycle(undefined);
    } else {
      setConnection((prevModel: any) => {
        return {
          ...prevModel,
          dataCycle: "",
        };
      });
      setDataCycle("");
    }
  };

  const onChangeHaveSecModes = (event: any) => {
    setHaveSecModes(event.target.checked);
    if (!event.target.checked) {
      setConnection((prevModel: any) => {
        const { secModes, ...restExtraInfo } = prevModel.extraInfo;
        return {
          ...prevModel,
          extraInfo: restExtraInfo,
        };
      });
    }
  };

  const onChangeHaveSecPolicies = (event: any) => {
    setHaveSecPolicies(event.target.checked);
    if (!event.target.checked) {
      setConnection((prevModel: any) => {
        const { secPolicies, ...restExtraInfo } = prevModel.extraInfo;
        return {
          ...prevModel,
          extraInfo: restExtraInfo,
        };
      });
    }
  };

  const _update = () => {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .updateConnection(connection)
      .finally(() => {
        dispatch(showAndHideSpinner(false));
      })
      .then((res: any) => {
        if (res.data.status) {
          toast.success(`${t("dcs0101.message.success.update")}`);
          getConnDetail();
          if (openConnectionInfo) {
            setOpenConnectionInfo(false);
          } else if (openDataMap) {
            setOpenDataMap(false);
          }
        } else {
          if (res.data.message === ExceptionConstant.TABLE_NM_EXISTED) {
            toast.error(`${t("dcs0101.message.error.tableNmExisted")}`);
          } else {
            toast.error(`${t("dcs0101.message.error.update")}`);
          }
        }
      })
      .catch((err: any) => {
        toast.error(`${t("dcs0101.message.error.system")}`);
      });
  };

  function chk(params: any) {
    let _chk = true;
    if (params.connNm == null || params.connNm.trim() === "") {
      toast.error(`${t("dcs0101.message.required.connNm")}`);
      _chk = false;
    } else if (params.connProtTp == null || Object.keys(params.connProtTp).length === 0) {
      toast.error(`${t("dcs0101.message.required.connProtTp")}`);
      _chk = false;
    } else if (params.sltDataMap == null || Object.keys(params.sltDataMap).length === 0) {
      toast.error(`${t("dcs0101.message.required.dataMap")}`);
      _chk = false;
    } else if (params.ip == null || params.ip.toString().trim() === "") {
      toast.error(`${t("dcs0101.message.required.ip")}`);
      _chk = false;
    } else if (params.port == null || params.port.toString().trim() === "") {
      toast.error(`${t("dcs0101.message.required.port")}`);
      _chk = false;
    } else if (params.kafkaTopic == null || params.kafkaTopic.toString().trim() === "") {
      toast.error(`${t("dcs0101.message.required.kafkaTopic")}`);
      _chk = false;
    }

    if (params.connProtTp === VariablesConstant.PROTOCOL_MODBUS) {
      if (params.slaveId == null || params.slaveId.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.slaveId")}`);
        _chk = false;
      } else if (params.dataOffset == null || params.dataOffset.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.dataOffset")}`);
        _chk = false;
      } else if (params.quantity == null || params.quantity.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.quantity")}`);
        _chk = false;
      }
    }

    if (params.connProtTp === VariablesConstant.PROTOCOL_MQTT) {
      if (params.clientId == null || params.clientId.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.clientId")}`);
        _chk = false;
      } else if (params.topic == null || params.topic.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.topic")}`);
        _chk = false;
      }
    }

    if (params.connProtTp === VariablesConstant.PROTOCOL_OPC_UA) {
      if (params.serverName == null || params.serverName.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.serverName")}`);
        _chk = false;
      } else if (params.connectionType == null || Object.keys(params.connectionType).length === 0) {
        toast.error(`${t("dcs0101.message.required.connectionType")}`);
        _chk = false;
      }
    }

    if (!_chk) {
      setConnection((prevState: any) => {
        return {
          ...prevState,
          connNm: prevState.connNm || "",
          connProtTp: prevState.connProtTp || {},
          sltDataMap: prevState.sltDataMap || {},
          ip: prevState.ip || "",
          port: prevState.port || "",
          username: prevState.username || "",
          pwd: prevState.pwd || "",
          kafkaTopic: prevState.kafkaTopic || "",
          dataCycle: prevState.dataCycle || "",
          slaveId: prevState.slaveId || null,
          dataOffset: prevState.dataOffset || null,
          quantity: prevState.quantity || null,
          clientId: prevState.clientId || "",
          topic: prevState.topic || "",
          serverName: prevState.serverName || "",
          connectionType: prevState.connectionType || {},
        };
      });
    }
    return _chk;
  }

  const handleUpdate = () => {
    if (chk(connection)) {
      _update();
    }
  };

  const openNotiDialog = () => {
    setOpenNotification(true);
  };

  const closeNotiDialog = () => {
    setOpenNotification(false);
  };

  const handleChangeDataMapping = (event: any) => {
    setConnection({
      ...connection,
      sltDataMap: event,
    });
  };

  return (
    <>
      {openViewData && (
        <AppDialog open={openViewData} style={{ width: "75vw" }} onClose={closeViewData} title={`${t("dcs0101.title.dialog.viewData")}`} className="width-dialog">
          <Dcs0101ViewData onClose={closeViewData} tableNm={connection.tableNm} connectionId={connection.id}></Dcs0101ViewData>
        </AppDialog>
      )}
      {openConnectionInfo && (
        <AppDialog open={openConnectionInfo} style={{ width: "60vw" }} onClose={closeConnectionInfo} title={`${t("dcs0101.title.dialog.connectionInfo")}`} className="width-dialog">
          <ConnectionInfo
            model={connection}
            dataCycle={dataCycle}
            setDataCycle={setDataCycle}
            handleChange={handleChange}
            handleChangeProtTp={handleChangeProtTp}
            handleChangeConnectTp={handleChangeConnectTp}
            handleSelectSecModes={handleSelectSecModes}
            handleChangeDataMapping={handleChangeDataMapping}
            handleSelectSecPolicies={handleSelectSecPolicies}
            onChangeHaveDataCycle={onChangeHaveDataCycle}
            onChangeHaveSecModes={onChangeHaveSecModes}
            onChangeHaveSecPolicies={onChangeHaveSecPolicies}
            haveDataCycle={haveDataCycle}
            haveSecModes={haveSecModes}
            haveSecPolicies={haveSecPolicies}
          />
          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="custom-btn gradient" onClick={handleUpdate}>
              <i className="pi pi-save fs-16 me-2"></i>
              {t("confirm.button.save.text")}
            </button>

            <button type="button" onClick={closeConnectionInfo} className="custom-btn">
              <i className="pi pi-times fs-16 me-2"></i>
              {t("dialog.button.cancel.text")}
            </button>
          </div>
        </AppDialog>
      )}
      {openDataMap && (
        <AppDialog open={openDataMap} style={{ width: "50vw" }} onClose={closeDataMap} title={`${t("dcs0101.title.dialog.dataMapInfo")}`} className="width-dialog">
          <DataMapInfo handleChange={handleChange} model={connection} dataMap={dataMap} handleChangeDataMap={handleChangeDataMap} onAddRow={onAddRow} onDeleteRow={onDeleteRow} />
          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="custom-btn gradient" onClick={handleUpdate}>
              <i className="pi pi-save fs-16 me-2"></i>
              {t("confirm.button.save.text")}
            </button>

            <button type="button" onClick={closeDataMap} className="custom-btn">
              <i className="pi pi-times fs-16 me-2"></i>
              {t("dialog.button.cancel.text")}
            </button>
          </div>
        </AppDialog>
      )}
      {openNotification && (
        <AppDialog open={openNotification} style={{ width: "50vw" }} onClose={closeNotiDialog} title={`${t("dcs0101.title.dialog.connectionNotification")}`} className="width-dialog">
          <ConnectionNotification connId={props.connId} />
        </AppDialog>
      )}

      <div className="box">
        <div className="box-body">
          <div className="d-flex justify-content-between mb-3">
            <div className="box-title">
              <h3 className="mb-sm-0 mb-0 flex-grow-1">
                {t("dcs0101.label.connection")} {connection?.connNm}
              </h3>
            </div>

            <div className="d-flex align-items-center">
              <span className="d-flex">
                <div
                  className={
                    "col-lg-2 p-2 conn-status pe-0 border-success-subtle border-end border-1 " +
                    (connection?.status.commCd === VariablesConstant.CONNECTION_STATUS_RUNNING
                      ? "bg-success"
                      : connection?.status.commCd === VariablesConstant.CONNECTION_STATUS_NEW
                      ? "bg-warning"
                      : "bg-danger")
                  }>
                  <span>
                    <b>Status</b>
                  </span>
                  <div>{connection?.status.commNm}</div>
                </div>
                {listNoti && listNoti.length > 0 ? (
                  <div className="col-lg-10 p-2 ps-0 marquee-notification cursor-pointer" onClick={openNotiDialog}>
                    <Marquee speed={50}>
                      {listNoti.map((ele: any, index: any) => (
                        <div className="mx-4" key={index}>
                          <ConnectionNotiItem {...ele} />
                        </div>
                      ))}
                    </Marquee>
                  </div>
                ) : (
                  <div className="col-lg-10 d-flex align-items-center justify-content-center p-2 ps-0 marquee-notification cursor-pointer">
                    <span>There are currently no notification.</span>
                  </div>
                )}
              </span>
            </div>
            <div className="button-head-body d-flex gap-2">
              <button onClick={back} type="button" className="custom-btn">
                <i className="pi pi-arrow-left fs-16 me-2"></i> {t("common.button.label.back")}
              </button>
              {connection?.status.commCd === VariablesConstant.CONNECTION_STATUS_RUNNING && (
                <button onClick={restart} type="button" className="custom-btn btn-dark">
                  <i className="pi pi-refresh fs-16 me-2"></i> {t("common.button.label.restart")}
                </button>
              )}
              {connection?.status.commCd === VariablesConstant.CONNECTION_STATUS_RUNNING && (
                <button onClick={stop} type="button" className="custom-btn btn-danger">
                  <i className="pi pi-stop fs-16 me-2"></i> {t("common.button.label.stop")}
                </button>
              )}
              {(connection?.status.commCd === VariablesConstant.CONNECTION_STATUS_STOPPED || connection?.status.commCd === VariablesConstant.CONNECTION_STATUS_NEW) && (
                <button onClick={start} type="button" className="custom-btn gradient">
                  <i className="pi pi-play fs-16 me-2"></i> {t("common.button.label.start")}
                </button>
              )}
            </div>
          </div>
          <div className="row" style={{ height: "600px" }}>
            {!loadingNodes && (
              <ReactFlow nodes={nodes} nodeTypes={nodeTypes} edges={edges} zoomOnScroll={false} zoomOnDoubleClick={false} panOnDrag={false} proOptions={{ hideAttribution: true }} fitView>
                <Background />
              </ReactFlow>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
